import { useState } from 'react';
import { Box, HStack, Text, Button, Flex } from '@chakra-ui/react';
import { LuCookie } from 'react-icons/lu';
import { AnimatePresence } from 'motion/react';
import { MotionBox } from '@components/ui/motion';
import { slideFromBottom } from '@utils/motion';

export default function CookieConsentBanner() {
  const [consent, setConsent] = useState(localStorage.getItem('cookie_consent'));

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    window.affonsoConsentGranted?.();
    setConsent('accepted');
  };

  const decline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setConsent('declined');
  };

  const show = consent === null;

  return (
    <AnimatePresence>
    {show && (
    <MotionBox
      key="cookie-banner"
      variants={slideFromBottom}
      initial="initial"
      animate="animate"
      exit="exit"
      position="fixed"
      bottom={4}
      left={{ base: 3, md: 4 }}
      right={{ base: 3, md: 4 }}
      zIndex={20}
      bg="white"
      borderRadius="16px"
      boxShadow="0 8px 30px rgba(0,0,0,0.15)"
      px={4}
      py={4}
    >
      <Flex
        direction={{ base: "column", md: "row" }}
        align={{ base: "stretch", md: "center" }}
        gap={4}
      >
        <HStack flex={1} align="center" justify="space-evenly" gap={3}>
          <Box
            p={2}
            borderRadius="full"
            bg="blue.50"
            flexShrink={0}
          >
            <LuCookie size={24} />
          </Box>

          <Text
            fontSize="sm"
            color="gray.700"
            lineHeight="1.5"
          >
            Nous utilisons des cookies pour mesurer nos performances
            et améliorer votre expérience. Acceptez-vous leur
            utilisation ?
          </Text>
        </HStack>

        <HStack
          gap={2}
          justify={{ base: "stretch", md: "flex-end" }}
          width={{ base: "100%", md: "auto" }}
        >
          <Button
            flex={{ base: 1, md: "unset" }}
            variant="outline"
            onClick={decline}
          >
            Refuser
          </Button>

          <Button
            flex={{ base: 1, md: "unset" }}
            colorPalette="blue"
            onClick={accept}
          >
            Accepter
          </Button>
        </HStack>
      </Flex>
    </MotionBox>
    )}
    </AnimatePresence>
  );
}
